import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Fragment } from 'preact';
import { hasTextContent, hasVisibleText, resolveDisplayHtml, resolveDisplayText, } from '../utils';
export function OfferText({ offer, styles, isMobile, macroAttributes, contentStyle, isFirstOfferFirstTime }) {
    // Determine text alignment: on mobile use align_content setting, on desktop always left
    const getTextAlign = () => {
        if (isMobile) {
            return styles.offerText?.align_content === 'center' ? 'center' : 'left';
        }
        return 'left';
    };
    const textAlign = getTextAlign();
    const titleStyles = {
        width: '100%',
        fontSize: styles.header?.heading_font_size || '18px',
        fontWeight: 'bold',
        color: styles.offerText?.textColor || '#333333',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
        lineHeight: '1.3',
        textAlign,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        backfaceVisibility: 'hidden',
        marginTop: isFirstOfferFirstTime ? '' : '8px',
    };
    const descriptionStyles = {
        fontSize: styles.offerText?.fontSize || '14px',
        color: styles.offerText?.textColor || '#666666',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
        lineHeight: '1.4',
        textAlign,
        backfaceVisibility: 'hidden',
    };
    // The line-clamp uses `-webkit-box`, which mangles list rendering and truncates
    // lists to 6 lines. Apply it only when the description has no <ul>/<ol> so list
    // content renders as a normal block (matches legacy `styleListElement`).
    const clampStyles = {
        display: '-webkit-box',
        WebkitLineClamp: 6,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    };
    // On mobile, prefer short fields when present; fall back to full fields.
    // Desktop always uses title / description.
    const rawTitle = isMobile ? (offer.short_headline || offer.title) : offer.title;
    const rawDescription = isMobile
        ? (offer.short_description || offer.description)
        : offer.description;
    const macroAttrs = {
        ...(macroAttributes || {}),
        title: offer.title,
        description: offer.description || '',
        advertiser_name: offer.advertiser_name,
        short_headline: offer.short_headline,
        short_description: offer.short_description,
    };
    const displayTitle = resolveDisplayText(rawTitle, macroAttrs);
    const displayDescription = resolveDisplayHtml(rawDescription, macroAttrs);
    return (_jsxs(Fragment, { children: [hasVisibleText(displayTitle) && (_jsx("h3", { id: 'adpx_offer-title', className: 'adpx_offer-title', style: { ...titleStyles, ...contentStyle }, children: displayTitle })), hasTextContent(displayDescription) && (_jsx("div", { id: 'adpx_offer-description', className: 'adpx_offer-description', "data-align": textAlign, style: {
                    ...descriptionStyles,
                    ...(/<(ul|ol)[\s>]/i.test(displayDescription) ? {} : clampStyles),
                    ...contentStyle,
                }, dangerouslySetInnerHTML: { __html: displayDescription } }))] }));
}
